import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "accountFormat",
})

// Example of account number pipe
// Input: 020109220000147977
// Output: 020 109 2200 0014 797 7
// account_format: [3, 3, 4, 4, 3, 1]
// It is possible to add more formats for different types of number using arrays
export class AccountFormatPipe implements PipeTransform {
  constructor() {}
  transform(value: string | number, type: string = "account"): string {
    return this.parse(Array.from(value.toString()), type);
  }

  parse(value, option) {
    let array = [];
    const account_format = [3, 3, 4, 4, 3, 1];
    switch (option) {
      case "account":
      default:
        for (const slice of account_format) {
          array.push(value.splice(0, slice).join(""));
        }
        break;
    }
    return array.join(" ");
  }
}
